function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation } from "@apollo/client";
import * as Sentry from "@sentry/core";
import batchPromises from "batch-promises";
import { useCallback, useContext, useState } from "react";
import { v4 as uuid } from "uuid";
import { graphql } from "@oui/lib/src/graphql/tada";
import { Kind } from "@oui/lib/src/types";
import { UploadType } from "@oui/lib/src/types/graphql.generated";
import { ActivityIndicator } from "./ActivityIndicator";
import { ChatInputChoice } from "./ChatInputChoice";
import { Text } from "./Text";
import { View } from "./View";
import { launchMediaPickerAsync } from "../lib/launchMediaPickerAsync";
import { ResumableUploadManagerContext } from "../lib/resumableUploadManager";
var noopOnInput = function() {};
export var ChatInputMediaPickerUploadMutation = graphql("\n  mutation ChatInputMediaPickerUpload($input: ResumableAssetCreateInput!) {\n    uploadResumableAsset(input: $input) {\n      resumableUploadAssetURI\n    }\n  }\n");
/**
 * This component provides a media picker interface for chat input, allowing
 * users to upload images and videos. It manages the upload process through a
 * resumable upload manager, displaying upload progress and handling errors.
 * Users can select media from their gallery or capture new photos. It supports
 * skipping uploads and retries, updating the UI accordingly based on remaining
 * uploads. The component also integrates Sentry for error tracking and
 * analytics throughout the upload process.
 *
 * @docsource llm
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-60}
 */ export function ChatInputMediaPicker(_param) {
    var _param_onInput = _param.onInput, onInput = _param_onInput === void 0 ? noopOnInput : _param_onInput, props = _object_without_properties(_param, [
        "onInput"
    ]);
    var resumableUploadManager = useContext(ResumableUploadManagerContext);
    var _useState = _sliced_to_array(useState(0), 2), uploadsRemaining = _useState[0], setUploadsRemaining = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), retryCount = _useState1[0], setRetryCount = _useState1[1];
    var _props_allowSkip;
    var _useState2 = _sliced_to_array(useState((_props_allowSkip = props.allowSkip) !== null && _props_allowSkip !== void 0 ? _props_allowSkip : false), 2), allowSkip = _useState2[0], setAllowSkip = _useState2[1];
    var _useMutation = _sliced_to_array(useMutation(ChatInputMediaPickerUploadMutation), 1), uploadAsset = _useMutation[0];
    var label = {
        0: 'Add from gallery',
        1: 'Take photo with camera'
    };
    if (allowSkip) {
        label[2] = 'Not now';
    }
    var processAsset = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(asset) {
            var fileName, type, uri, ID, start, _asset_fileName;
            return _ts_generator(this, function(_state) {
                fileName = asset.fileName, type = asset.type, uri = asset.uri;
                ID = uuid();
                start = Date.now();
                Sentry.addBreadcrumb({
                    message: 'ChatInputMediaPicker uploading asset',
                    data: asset
                });
                return [
                    2,
                    uploadAsset({
                        variables: {
                            input: {
                                context: props.context,
                                key: "".concat(props.keyPrefix, "_").concat(ID),
                                uploadType: type === 'video' ? UploadType.VIDEO : UploadType.IMAGE,
                                fileName: (_asset_fileName = asset.fileName) !== null && _asset_fileName !== void 0 ? _asset_fileName : 'unknown'
                            }
                        }
                    }).then(/*#__PURE__*/ function() {
                        var _ref = _async_to_generator(function(assetResult) {
                            var id;
                            return _ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            resumableUploadManager.uploadFile(uri, assetResult.data.uploadResumableAsset.resumableUploadAssetURI)
                                        ];
                                    case 1:
                                        id = _state.sent();
                                        return [
                                            2,
                                            new Promise(function(resolve) {
                                                var remove = resumableUploadManager.addListener(id, function(param) {
                                                    var percent = param.percent;
                                                    if (percent === 100) {
                                                        resolve();
                                                        remove();
                                                    }
                                                });
                                            })
                                        ];
                                }
                            });
                        });
                        return function(assetResult) {
                            return _ref.apply(this, arguments);
                        };
                    }()).catch(function(e) {
                        Sentry.withScope(function(scope) {
                            scope.setExtras({
                                duration: Date.now() - start,
                                fileName: fileName,
                                type: type,
                                uri: uri
                            });
                            Sentry.captureException(e);
                        });
                    }).then(function() {
                        Sentry.addBreadcrumb({
                            message: 'ChatInputMediaPicker upload complete',
                            data: _object_spread({
                                duration: Date.now() - start
                            }, asset)
                        });
                        setUploadsRemaining(function(i) {
                            return i - 1;
                        });
                    })
                ];
            });
        });
        return function(asset) {
            return _ref.apply(this, arguments);
        };
    }(), [
        props.context,
        props.keyPrefix,
        uploadAsset,
        resumableUploadManager
    ]);
    var launchImagePicker = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(mode) {
            var result, assets;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            launchMediaPickerAsync(mode, {
                                allowsMultipleSelection: true,
                                mediaTypes: [
                                    'images',
                                    'videos'
                                ],
                                orderedSelection: true
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        if (result.canceled && 'denied' in result && result.denied) {
                            onInput({
                                kind: Kind.InputMediaPicker,
                                props: {
                                    result: 'denied'
                                }
                            });
                        }
                        if (result === null || result === void 0 ? void 0 : result.canceled) {
                            setRetryCount(function(c) {
                                return c + 1;
                            });
                            return [
                                2
                            ];
                        }
                        if (result === null || result === void 0 ? void 0 : result.assets) {
                            assets = result.assets;
                            if (!assets.length) {
                                setAllowSkip(true);
                                setRetryCount(function(c) {
                                    return c + 1;
                                });
                                return [
                                    2
                                ];
                            }
                            setUploadsRemaining(assets.length);
                            batchPromises(3, assets, processAsset).then(function() {
                                onInput({
                                    kind: Kind.InputMediaPicker,
                                    props: {
                                        result: 'gallery'
                                    }
                                });
                            }).catch(function(e) {
                                return Sentry.captureException(e);
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(mode) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onInput,
        processAsset
    ]);
    return /*#__PURE__*/ _jsx(View, {
        flex: uploadsRemaining ? 1 : 0,
        children: uploadsRemaining ? /*#__PURE__*/ _jsxs(View, {
            row: true,
            style: {
                justifyContent: 'center',
                flex: 1
            },
            spacing: 8,
            children: [
                /*#__PURE__*/ _jsx(ActivityIndicator, {}),
                /*#__PURE__*/ _jsx(Text, {
                    text: "Uploading (".concat(uploadsRemaining, " remaining)...")
                })
            ]
        }) : /*#__PURE__*/ _jsx(ChatInputChoice, {
            onInput: function(action) {
                var perform = function perform() {
                    return _perform.apply(this, arguments);
                };
                function _perform() {
                    _perform = _async_to_generator(function() {
                        var choice;
                        return _ts_generator(this, function(_state) {
                            if (action.kind === Kind.InputChoice) {
                                choice = action.props[0];
                                if (choice === 0) {
                                    void launchImagePicker('gallery');
                                } else if (choice === 1) {
                                    void launchImagePicker('camera');
                                } else if (choice === 2) {
                                    onInput({
                                        kind: Kind.InputMediaPicker,
                                        props: {
                                            result: 'skip'
                                        }
                                    });
                                }
                            }
                            return [
                                2
                            ];
                        });
                    });
                    return _perform.apply(this, arguments);
                }
                perform().catch(function(e) {
                    Sentry.captureException(e);
                    setRetryCount(function(c) {
                        return c + 1;
                    });
                });
            },
            label: label
        }, retryCount.toString())
    });
}
export default ChatInputMediaPicker;
